import Logo from "../assets/Logo.png";
import WaterIcon from "../assets/WaterIcon.png";

type Props = {};

const PageNew3 = (props: Props) => {
  return (
    <div className="flex justify-center items-center w-screen h-screen  bg-[#181818]">
      <div className="w-[410px] h-[256px] bg-[#181818] flex flex-col items-center ">
        <h1 className="text-4xl font-semibold text-white mt-4 text-center mb-8">
          Fresh water is 0.002% on Earth
        </h1>
        <div className="grid grid-cols-3 w-full gap-16 mt-2">
          <div className="flex justify-center items-center">
            <img src={WaterIcon} className="w-18 h-18" />
          </div>
          <div className="flex flex-col w-96 justify-center  ">
            <h1 className="text-white -ml-[5rem] text-4xl font-semibold ">
              SAVE WATER
            </h1>
            <h1 className="text-white -ml-10 text-4xl font-semibold ">
              SAVE EARTH
            </h1>
          </div>
          <div className="flex justify-center items-center ml-4 ">
            <img src={Logo} className=" w-18 h-18 object-contain " />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNew3;
